var exports = {
  "message__layout": "x61f99309--8783e3--message__layout",
  "message__layout_type_outcoming": "x61f99309--8783e3--message__layout_type_outcoming",
};

module.exports = exports;
